
import {Link} from "react-router-dom";
import logo from '../assets/logo.png';
import { useRef } from "react";
import { Collapse } from "bootstrap";
import { useEffect } from "react";


const NavBar =()=>{
  const navCollapseRef = useRef(null);

  const handleNavClick = () => {
        if (window.innerWidth >= 992) return;
        const collapseElement = navCollapseRef.current;
        let bsCollapse = Collapse.getInstance(collapseElement);

        if (!bsCollapse) {
          bsCollapse = new Collapse(collapseElement);
        }

        bsCollapse.hide();
     };

    useEffect(() => {
        const handleClickOutside = (event) => {
           if (window.innerWidth >= 992) return;
          const collapseElement = navCollapseRef.current;
          const toggler = document.querySelector(".navbar-toggler");

          if (
            collapseElement &&
            collapseElement.classList.contains("show") &&
            !collapseElement.contains(event.target) &&
            !toggler.contains(event.target)
          ) {
            const bsCollapse = Collapse.getInstance(collapseElement);
            if (bsCollapse) {
              bsCollapse.hide();
            }
          }
        };

        document.addEventListener("click", handleClickOutside);

        return () => {
          document.removeEventListener("click", handleClickOutside);
        };
      }, []); 

    return (
      <div>
        <nav className="navbar fixed-top navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
            <Link className="navbar-brand ps-0 ms-4 p-2" to="/">
            <img src={logo} alt="Logo" height="50" />
            </Link>
            <button
          className="navbar-toggler border-0 shadow-none"
            type="button"
            onClick={() => {
              const collapseElement = navCollapseRef.current;
              let bsCollapse = Collapse.getOrCreateInstance(collapseElement);
              bsCollapse.toggle();
            }}
          >
          <span className="navbar-toggler-icon"></span>
          </button>
            <div 
         className="collapse navbar-collapse ps-4 ps-lg-0" 
         id="navbarSupportedContent"
        ref={navCollapseRef}
      >
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-5">
                <li className="nav-item px-lg-3 my-2 my-lg-0">
                <Link className="nav-link active" aria-current="page" to="/" onClick={handleNavClick}>Home</Link>
                </li>
                <li className="nav-item px-lg-3 my-2 my-lg-0">
                <Link className="nav-link active" aria-current="page" to="/about" onClick={handleNavClick}>About</Link>
                </li>  
                <li className="nav-item px-lg-3 my-2 my-lg-0">
                <Link className="nav-link active" aria-current="page" to="/projects" onClick={handleNavClick}>Projects</Link>
                </li>  
                <li className="nav-item px-lg-3 my-2 my-lg-0">
                <Link className="nav-link active" aria-current="page" to="/career" onClick={handleNavClick}>Career</Link>
                </li>
                <li className="nav-item px-lg-3 my-2 my-lg-0">
                <Link className="nav-link active" aria-current="page" to="/contact" onClick={handleNavClick}>Contact</Link>
                </li>
                <li className="nav-item px-lg-3 my-2 my-lg-0">
                <Link className="nav-link active" aria-current="page" to="/blog" onClick={handleNavClick}>Blog</Link>
                </li>      
            </ul> 
            <div className="d-flex ms-auto me-4">
            <Link 
              to="/register" 
              className="btn" 
              style={{ backgroundColor: "#FF8F1C", color: "white" }}
            >
              Register Now <span className="ms-2">&rarr;</span>
            </Link>
</div>
            </div>
        </div>
        </nav>
        
      </div>
    )
  //}
}

export default NavBar
